function surveyjsslidersix(Survey) {

  var widget = {
    name: 'hexaslider',
    title: 'Hexa Slider',
    iconName: '',
    //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
    widgetIsLoaded: function () {
        return typeof $ == "function" && !!slidersix; //return true if jQuery and select2 widget are loaded on the page
    },
    //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
    isFit: function (question) {
        return question.getType() === 'hexaslider';
    },
    activatedByChanged: function (activatedBy) {
        //We are creating a new class and derived it from rating question type. It means that text model (properties and fuctions) will be available to us
        Survey.JsonObject.metaData.addClass('hexaslider', [], null, 'rating');

        //Add new property(s)
        //For more information go to https://surveyjs.io/Examples/Builder/?id=addproperties#content-docs
        // Survey.JsonObject.metaData.addProperties('hexaslider', [
        //     { name: 'minValue', default: 0},
        //     { name: 'maxValue', default: 10}
        // ]);
    },
    isDefaultRender: false,
    htmlTemplate: '<div></div>',
    //The main function, rendering and two-way binding
    afterRender: function (question, el) {

        var ret = slidersix({
          target: el,
          max: question.rateMax ? question.rateMax : 5,
          min: question.rateMin || question.rateMin === 0 ? question.rateMin : 1,
          steps: question.rateStep ? question.rateStep : 1,
          el: el,
          maxDescription: question.maxRateDescription ? question.maxRateDescription :'',
          minDescription: question.minRateDescription ? question.minRateDescription : '',
          initialValue: question.value
        });

         $(ret.valueElement).on('change', (e) => {
           question.value = e.currentTarget.value;
         });
        // // //if question becomes readonly/enabled add/remove disabled attribute
        // // question.readOnlyChangedCallback = onReadOnlyChangedCallback;
        // // //if the question value changed in the code, for example you have changed it in JavaScript
        //  question.valueChangedCallback = onValueChangedCallback;
        // // //set initial value
        //  onValueChangedCallback();
        // // //make elements disabled if needed
        // // onReadOnlyChangedCallback();
    },
    //Use it to destroy the widget. It is typically needed by jQuery widgets
    willUnmount: function (question, el) {
        //We do not need to clear anything in our simple example
        //Here is the example to destroy the image picker
        //var $el = $(el).find("select");
        //$el.data('picker').destroy();
    },
};

  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, "customtype");
}

if (typeof Survey !== "undefined") {
  surveyjsslidersix(Survey);
}
